module.exports = __webpack_public_path__ + "static/media/hall-P11.8bf22a06.svg";